import { Avatar } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Box, Modal } from "@mui/material";
import { AccessRoles, AccessRolesConst } from "../../../../Utils/Roles";
import { toast } from "react-toastify";
import SelectedRole from "../../Members/SelectedRole";
import RoleComp from "../../Members/RoleComp";

const btnStyle = {
  background: "#111827",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  fontFamily: "Nunito",
  fontWeight: 700,
  cursor: "pointer",
};

export default function AllCorporates() {
  const [allcorps, setallcorps] = useState([]);
  const [selectCorp, setSelectCorp] = useState(null);
  const [email, setEmail] = useState("");
  const [roles, setRoles] = useState(AccessRoles);
  const [searchVal, setSearchVal] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [open, setOpen] = useState(false);

  const fetchCorps = async () => {
    await axios({ url: "/api/corporate/all", method: "get" })
      .then((res) => {
        if (res.data.success) setallcorps(res.data.data);
      })
      .catch((err) => console.log(err.message));
  };

  const handleInvite = async (e) => {
    e.preventDefault();
    if (!email || email === " ") {
      toast.error("Email can not be empty", { position: "bottom-right" });
      return;
    }
    if (
      !roles[AccessRolesConst.admin_service] &&
      !roles[AccessRolesConst.valuation_service] &&
      !roles[AccessRolesConst.pitchdeck_Service] &&
      !roles[AccessRolesConst.insights_Service] &&
      !roles[AccessRolesConst.event_Management] &&
      !roles[AccessRolesConst.partnership_Service] &&
      !roles[AccessRolesConst.gd_service] &&
      !roles[AccessRolesConst.recruitment_Service] &&
      !roles[AccessRolesConst.connection_service] &&
      !roles[AccessRolesConst.mi_service]
    ) {
      toast.error("Role can not be empty", { position: "bottom-right" });
      return;
    }
    if (!selectCorp?._id) {
      toast.error("No corporate selected");
      return;
    }
    await axios({
      method: "POST",
      url: `/api/corporate/invite/${selectCorp._id}`,
      data: { email, role: roles, user: selectCorp.id },
    })
      .then((res) => {
        if (res.data.success) {
          toast.success("Invite sent", { position: "bottom-right" });
          setOpen(false);
          setEmail("");
          setRoles(AccessRoles);
        } else {
          toast.error("Email already registered", { position: "bottom-right" });
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.message ?? "Error", { position: "bottom-right" });
      });
  };

  useEffect(() => { fetchCorps(); }, []);

  return (
    <div style={{ padding: "36px 40px", maxWidth: 1200, boxSizing: "border-box", margin: "0 auto" }}>

      {/* Header */}
      <div style={{ marginBottom: 32 }}>
        <h1 style={{ fontFamily: "Nunito", fontWeight: 800, fontSize: 40, color: "#111827", margin: 0 }}>
          All Corporates
        </h1>
        <p style={{ fontFamily: "Nunito", fontSize: 14, color: "#6b7280", margin: "6px 0 0" }}>
          {allcorps.length} corporate{allcorps.length !== 1 ? "s" : ""}
        </p>
      </div>

      {/* Cards */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(360px, 1fr))", gap: 16 }}>
        {allcorps.map((corps, i) => (
          <div key={i} style={{
            background: "#ffffff",
            border: "1px solid #e5e7eb",
            borderRadius: 12,
            padding: "16px 20px",
            display: "flex",
            alignItems: "center",
            gap: 14,
          }}>
            <Avatar
              src={corps.logo}
              style={{ width: 52, height: 52, flexShrink: 0, border: "1px solid #e5e7eb" }}
            />
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{ fontFamily: "Nunito", fontWeight: 700, fontSize: 15, color: "#111827", margin: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {corps.nameOfCorporateType}
              </p>
              <p style={{ fontFamily: "Nunito", fontSize: 12, color: "#6b7280", margin: "4px 0 0", fontWeight: 600 }}>
                {corps.userJoined?.length ?? 0} / {corps.companySize} members
              </p>
            </div>
            <button
              style={{ ...btnStyle, padding: "8px 16px", fontSize: 12, flexShrink: 0 }}
              onMouseEnter={e => (e.currentTarget.style.background = "#374151")}
              onMouseLeave={e => (e.currentTarget.style.background = "#111827")}
              onClick={() => { setOpen(true); setSelectCorp(corps); }}
            >
              Add Members
            </button>
          </div>
        ))}
      </div>

      {allcorps.length === 0 && (
        <div style={{ textAlign: "center", padding: "60px 0", color: "#9ca3af", fontFamily: "Nunito", fontSize: 15 }}>
          No corporates found.
        </div>
      )}

      {/* Modal */}
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          bgcolor: "#ffffff",
          borderRadius: "16px",
          boxShadow: "0 25px 60px rgba(0,0,0,0.15)",
          outline: "none",
          overflow: "hidden",
        }}>
          {/* Modal header */}
          <div style={{ padding: "22px 28px", borderBottom: "1px solid #f3f4f6", display: "flex", alignItems: "center", gap: 14 }}>
            {selectCorp && (
              <>
                <Avatar src={selectCorp.logo} style={{ width: 46, height: 46, border: "1px solid #e5e7eb" }} />
                <div>
                  <p style={{ margin: 0, fontFamily: "Nunito", fontWeight: 800, fontSize: 17, color: "#111827" }}>
                    {selectCorp.nameOfCorporateType}
                  </p>
                  <p style={{ margin: 0, fontFamily: "Nunito", fontSize: 12, color: "#6b7280" }}>
                    Invite a new member
                  </p>
                </div>
              </>
            )}
          </div>

          {/* Modal body */}
          <form onSubmit={handleInvite} onClick={() => setIsOpen(false)} style={{ padding: "24px 28px" }}>
            {/* Email */}
            <div style={{ marginBottom: 20 }}>
              <label style={{ fontFamily: "Nunito", fontSize: 13, fontWeight: 700, color: "#374151", display: "block", marginBottom: 6 }}>
                Email Address
              </label>
              <input
                required
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="email@company.com"
                style={{
                  width: "100%",
                  height: 42,
                  border: "1px solid #e5e7eb",
                  borderRadius: 8,
                  padding: "0 14px",
                  fontFamily: "Nunito",
                  fontSize: 14,
                  color: "#111827",
                  outline: "none",
                  boxSizing: "border-box",
                  background: "#f9fafb",
                }}
              />
            </div>

            {/* Role */}
            <div style={{ marginBottom: 24 }} onClick={(e) => e.stopPropagation()}>
              <label style={{ fontFamily: "Nunito", fontSize: 13, fontWeight: 700, color: "#374151", display: "block", marginBottom: 6 }}>
                Role
              </label>
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  value={searchVal}
                  onChange={(e) => setSearchVal(e.target.value)}
                  onFocus={() => setIsOpen(true)}
                  placeholder="Search and select role"
                  style={{
                    width: "100%",
                    height: 42,
                    border: "1px solid #e5e7eb",
                    borderRadius: 8,
                    padding: "0 40px 0 14px",
                    fontFamily: "Nunito",
                    fontSize: 14,
                    color: "#111827",
                    outline: "none",
                    boxSizing: "border-box",
                    background: "#f9fafb",
                  }}
                />
                <span style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" fill="none" viewBox="0 0 12 8">
                    <path fill="#9ca3af" d="M11.131.688H.87c-.308 0-.48.325-.29.546l5.132 5.95c.147.17.43.17.578 0l5.131-5.95c.19-.222.02-.546-.289-.546z" />
                  </svg>
                </span>
              </div>
              <RoleComp isOpen={isOpen} setIsOpen={setIsOpen} setRoles={setRoles} roles={roles} searchVal={searchVal} />
              <SelectedRole roles={roles} setRoles={setRoles} />
            </div>

            {/* Submit */}
            <button
              type="submit"
              style={{ ...btnStyle, width: "100%", height: 44, fontSize: 14 }}
              onMouseEnter={e => (e.currentTarget.style.background = "#374151")}
              onMouseLeave={e => (e.currentTarget.style.background = "#111827")}
            >
              Send Invite
            </button>
          </form>
        </Box>
      </Modal>
    </div>
  );
}
